<template>
  <div id="preloader" :class="ready ? 'hide' : null">
    <div class="overlay"></div>
    <div id="animation">
      <lottie :options="options" :height="height" :width="width" v-on:animCreated="handleAnimation"/>
    </div>
  </div>
</template>

<script>
import Lottie from 'vue-lottie'
import animationData from '@/assets/logo-animation'

export default {
  components: {
    Lottie
  },
  data () {
    return {
      width: window.innerWidth <= 960 ? window.innerWidth : window.innerWidth / 2,
      height: window.innerWidth <= 960 ? window.innerHeight : window.innerHeight / 2,
      options: {
        loop: false,
        animationData: animationData
      },
      anim: null,
      ready: false
    }
  },
  mounted () {
    // const self = this
  },
  methods: {
    handleAnimation (lottie) {
      lottie.pause()
      const self = this
      setTimeout(() => {
        lottie.play()
      }, 500)
      self.lottie = lottie
      // lottie animation stop after 4700
      setTimeout(function () {
        lottie.pause()
        self.ready = true
        self.$eventBus.$emit('PAGE_LOADED')
      }, 4700)
    }
  }
}
</script>

<style lang="scss">
$preloader: (
  background: #dfdfdf
);

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: map-get($preloader, background);
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity .4s ease-in-out;

  #animation {
    opacity: 1;
    transition: opacity .4s ease-in-out;
  }

  &.hide {
    pointer-events: none;
    opacity: 0;

    #animation {
      opacity: 0;
    }
  }

  .overlay {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    background-color: #8D2480;
    transform-origin: bottom;
  }
}
</style>
